<script lang="ts">
  import type { Localizer } from "../l10n/localization.service";

  export let T: Localizer;
  export let successHtml: string;
</script>

{#if successHtml}
  <div style="margin-bottom: 1.2rem;">
    {@html successHtml}
  </div>
{:else}
  <div class="alert alert-success">{@html T.get("thankyou.successText")}</div>
{/if}
